import { Provider, Type } from '@angular/core';

import { provideValidator } from './provide-validator';
import { provideValueAccessor } from './provide-value-accessor';

export function provideValidatedValueAccessor(valueAccessorClass: Type<unknown>): Provider[] {
  return [provideValueAccessor(valueAccessorClass), provideValidator(valueAccessorClass)];
}
